import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { MEDIA_QUERY } from "@xe/constants";
import { type } from "@xe/util-common";
import Guilloche from "./guilloche";
var GUILLOCHE = {}; // a stub for what will become our store of guilloche constants
// Before SiteHeader sticks to the top (it sticks only after one has scrolled
// past the ad), FluidContainer needs padding-top so that its content isn’t
// obscured by SiteHeader’s content.

var FluidContainer =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "FluidContainer"
})(["background-color:", ";", " position:relative;"], function (_ref) {
  var _theme$fluidContainer;

  var theme = _ref.theme;
  return ((_theme$fluidContainer = theme.fluidContainer) == null ? void 0 : _theme$fluidContainer.backgroundColor) || "none";
}, function (_ref2) {
  var isAdjacentToSiteHeader = _ref2.isAdjacentToSiteHeader;
  return isAdjacentToSiteHeader ? "\n          padding-top: 73px;\n\n          " + MEDIA_QUERY.minWidthXs + " {\n            padding-top: 110px;\n          }\n        " : "";
});
var GuillocheContainer =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "GuillocheContainer"
})(["height:100%;left:calc(50% - 496px);position:absolute;top:0;width:992px;"]);
var GuillocheClipper =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "GuillocheClipper"
})(["position:absolute;top:0;width:100%;height:100%;overflow:hidden;"]);

var fluidContainer = function fluidContainer(_ref3) {
  var children = _ref3.children,
      guilloches = _ref3.guilloches,
      isAdjacentToSiteHeader = _ref3.isAdjacentToSiteHeader,
      style = _ref3.style,
      rest = _objectWithoutPropertiesLoose(_ref3, ["children", "guilloches", "isAdjacentToSiteHeader", "style"]);

  try {
    if (guilloches !== null && guilloches !== undefined) {
      if (type(guilloches) !== "array" || guilloches.length < 1 || !guilloches.every(function (guilloche) {
        return type(guilloche) === "object" || type(GUILLOCHE[guilloche]) === "object";
      })) {
        throw new Error("FluidContainer(): expected `guilloches` to be a non-empty array, " + "where each item is either an object or a key in an object where the " + "key’s value is an object. Check the value of your `guilloches` prop.");
      }
    }
  } catch (error) {
    guilloches = undefined;
    console.error(error);
  } // FIXME, please.


  var guillocheStyles = {
    background: "none",
    height: "100%",
    overflow: "hidden",
    position: "absolute",
    top: 0,
    width: "100%"
  };
  return (
    /*#__PURE__*/
    React.createElement(FluidContainer, _extends({
      isAdjacentToSiteHeader: isAdjacentToSiteHeader,
      style: style
    }, rest), !!guilloches &&
    /*#__PURE__*/
    React.createElement(GuillocheClipper, null,
    /*#__PURE__*/
    React.createElement(GuillocheContainer, null, guilloches.map(function (guilloche) {
      // 1. We still might need a better means of auto-generating unique IDs.
      // 2. We’re not using the array’s index as a unique ID because we don’t want
      //    to be warned about using array indices as keys if we turn this rule on:
      //
      //    https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-array-index-key.md
      guilloche.id = guilloche.id || Math.random();

      if (Object.prototype.hasOwnProperty.call(guilloche, "orientation")) {
        guilloche.orientation = Guilloche[guilloche.orientation];
      }

      return (
        /*#__PURE__*/
        React.createElement(Guilloche, _extends({}, guilloche, {
          key: guilloche.id,
          style: guilloche.style || guillocheStyles
        }))
      );
    }))), children)
  );
};

fluidContainer.displayName = "FluidContainer";
fluidContainer.propTypes = {
  children: PropTypes.node,
  guilloches: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
  isAdjacentToSiteHeader: PropTypes.bool,
  style: PropTypes.object
};
export default fluidContainer;